import React, { useState } from "react";
import { Formik, Field } from "formik";
import { connect } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { requestPassword } from "../_redux/authCrud";
import { notification } from "antd";
import MetaTags from "react-meta-tags";
import { CustomInput } from "../../../../utility/CustomInput";
import * as Yup from "yup";

const ForgotPassword = ({ intl }) => {
    const history = useHistory();
    const [isRequested, setIsRequested] = useState(false);

    if (isRequested) {
        return <Redirect to="/auth" />;
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Email is required")
            .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email address"),
    });

    return (
        <>
            <MetaTags>
                <title>Kommerce Hub | Forget Password</title>
                <meta
                    name="description"
                    content="Kommerce Hub - Empowering Commerce, On a mission to streamline your business operations and help you save your time and costs"
                />
            </MetaTags>
            <div className="login-form">
                <div className="text-center mb-10 mb-lg-20">
                   <h3 className="font-size-h1">Forgotten Password ?</h3>
                </div>
                <Formik
                    initialValues={{ email: "" }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setStatus, setSubmitting }) => {
                        requestPassword(values.email)
                            .then((res) => {
                                setSubmitting(false);
                                notification.success({ message: res.data.message, duration: 3 });
                                history.push("/auth/new-password")
                                // setIsRequested(true);
                            })
                            .catch((err) => {
                                setSubmitting(false);
                                setStatus(intl.formatMessage({ id: "AUTH.VALIDATION.NOT_FOUND" }, { name: values.email }));
                                err.response.data.errors.map((error) => notification.error({ message: error, duration: 5 }));
                            });
                    }}
                >
                    {({ values, handleSubmit, isSubmitting }) => (
                        <form onSubmit={handleSubmit} className="form">
                            <div className="form-group">
                                <Field type="email"
                                    name="email"
                                    component={CustomInput}
                                    className="login-input-fields"
                                    placeholder="Email"
                                // label="Email"
                                >
                                </Field>
                            </div>
                            <div className="form-group d-flex flex-wrap flex-center">
                            <Link to="/auth">
                                    <button type="button" id="kt_login_forgot_cancel" className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4">
                                        Cancel
                                    </button>
                                </Link>
                                <button id="kt_login_forgot_submit" type="submit" className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4" disabled={isSubmitting}>
                                    Submit
                                </button>
                                
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </>
    );
};

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
